const siteData = {
  header: {
    title: "Hilman Fikry",
    navLinks: [
      { label: "About", url: "#about" },
      { label: "Projects", url: "#projects" },
      { label: "Blog", url: "#blog" },
      { label: "Contact", url: "#contact" },
    ],
  },
  footer: {
    copyright: `&copy; ${new Date().getFullYear()} Hilman Fikry | The code for this website is open source.`,
    githubRepo: "https://github.com/gofhilman/homepage",
    githubLabel: "View on Github",
  },
};

export default siteData;
